import script from "./AnomaliesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnomaliesPage.vue?vue&type=script&setup=true&lang=js"

import "./AnomaliesPage.vue?vue&type=style&index=0&id=6e413132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e413132"]])

export default __exports__